module.exports = __webpack_public_path__ + "img/ennetix-applications-page.87959381.png";